import './assets/sass/fonts.scss';
import Vue from 'vue';
import PortalVue from 'portal-vue'
import router from './router';
import i18n from './i18n';
import App from './App.vue';

Vue.use(PortalVue);
Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
